import Color from "terriajs-cesium/Source/Core/Color";
import isDefined from "../../../Core/isDefined";
import { OutlineSymbolTraits } from "../../../Traits/TraitsClasses/Table/OutlineStyleTraits";
import TablePointSizeStyleTraits from "../../../Traits/TraitsClasses/Table/PointSizeStyleTraits";
import { PointSymbolTraits } from "../../../Traits/TraitsClasses/Table/PointStyleTraits";
import createStratumInstance from "../../Definition/createStratumInstance";
export function esriStyleToTableStyle(esriStyle, label) {
  var _convertEsriColorToCe, _convertEsriPointSize, _convertEsriPointSize2, _esriStyle$xoffset, _esriStyle$yoffset, _esriStyle$outline, _convertEsriColorToCe2, _convertEsriColorToCe3, _esriStyle$outline2, _esriStyle$outline3, _esriStyle$outline4;
  if (!esriStyle) return {};
  return {
    // For esriPMS - just use white color
    // This is so marker icons aren't colored by default
    color: esriStyle.type === "esriPMS" ? "#FFFFFF" : (_convertEsriColorToCe = convertEsriColorToCesiumColor(esriStyle.color)) === null || _convertEsriColorToCe === void 0 ? void 0 : _convertEsriColorToCe.toCssColorString(),
    pointSize: createStratumInstance(TablePointSizeStyleTraits, {}),
    point: createStratumInstance(PointSymbolTraits, {
      marker: esriStyle.type === "esriPMS" ? "data:".concat(esriStyle.contentType, ";base64,").concat(esriStyle.imageData) : convertEsriMarkerToMaki(esriStyle.style),
      // symbol.size is used by "esriSMS"
      // height and width is used by "esriPMS"
      height: (_convertEsriPointSize = convertEsriPointSizeToPixels(esriStyle.size)) !== null && _convertEsriPointSize !== void 0 ? _convertEsriPointSize : convertEsriPointSizeToPixels(esriStyle.height),
      width: (_convertEsriPointSize2 = convertEsriPointSizeToPixels(esriStyle.size)) !== null && _convertEsriPointSize2 !== void 0 ? _convertEsriPointSize2 : convertEsriPointSizeToPixels(esriStyle.width),
      rotation: esriStyle.angle,
      pixelOffset: [(_esriStyle$xoffset = esriStyle.xoffset) !== null && _esriStyle$xoffset !== void 0 ? _esriStyle$xoffset : 0, (_esriStyle$yoffset = esriStyle.yoffset) !== null && _esriStyle$yoffset !== void 0 ? _esriStyle$yoffset : 0],
      legendTitle: label || undefined
    }),
    outline: ((_esriStyle$outline = esriStyle.outline) === null || _esriStyle$outline === void 0 ? void 0 : _esriStyle$outline.style) !== "esriSLSNull" ? createStratumInstance(OutlineSymbolTraits, {
      color: esriStyle.type === "esriSLS" ? (_convertEsriColorToCe2 = convertEsriColorToCesiumColor(esriStyle.color)) === null || _convertEsriColorToCe2 === void 0 ? void 0 : _convertEsriColorToCe2.toCssColorString() : (_convertEsriColorToCe3 = convertEsriColorToCesiumColor((_esriStyle$outline2 = esriStyle.outline) === null || _esriStyle$outline2 === void 0 ? void 0 : _esriStyle$outline2.color)) === null || _convertEsriColorToCe3 === void 0 ? void 0 : _convertEsriColorToCe3.toCssColorString(),
      // Use width if Line style
      width: esriStyle.type === "esriSLS" ? convertEsriPointSizeToPixels(esriStyle.width) : convertEsriPointSizeToPixels((_esriStyle$outline3 = esriStyle.outline) === null || _esriStyle$outline3 === void 0 ? void 0 : _esriStyle$outline3.width),
      legendTitle: label || undefined,
      dash: esriStyle.type === "esriSLS" ? convertEsriLineStyleToDashArray(esriStyle.style) : convertEsriLineStyleToDashArray((_esriStyle$outline4 = esriStyle.outline) === null || _esriStyle$outline4 === void 0 ? void 0 : _esriStyle$outline4.style)
    }) : undefined
  };
}
function convertEsriMarkerToMaki(esri) {
  switch (esri) {
    case "esriSMSCross":
      return "hospital";
    case "esriSMSDiamond":
      return "diamond";
    case "esriSMSSquare":
      return "square";
    case "esriSMSTriangle":
      return "triangle";
    case "esriSMSX":
      return "cross";
    case "esriSMSCircle":
    default:
      return "point";
  }
}

// ESRI uses points for styling while cesium uses pixels
export function convertEsriPointSizeToPixels(pointSize) {
  if (!isDefined(pointSize)) return undefined;
  // 1 px = 0.75 point
  // 1 point = 4/3 point
  return pointSize * 4 / 3;
}
function convertEsriColorToCesiumColor(esriColor) {
  if (!esriColor) return;
  return Color.fromBytes(esriColor[0], esriColor[1], esriColor[2], esriColor[3]);
}
const defaultDashArray = [4, 3];
const esriLineStyleCesium = {
  esriSLSNull: 0,
  esriSLSSolid: 255,
  esriSLSDash: 3087,
  //"   ----" parseInt("110000001111", 2)
  esriSLSDot: 7,
  //"   -"
  esriSLSDashDot: 2017,
  //"   ----   -"
  esriSLSDashDotDot: 16273,
  // '  --------   -   - '
  esriSLSLongDash: 2047,
  // '   --------'
  esriSLSLongDashDot: 4081,
  // '   --------   -'
  esriSLSShortDash: 4095,
  //' ----'
  esriSLSShortDot: 13107,
  //' ---- -'
  esriSLSShortDashDot: 8179,
  //' ---- - -'
  esriSLSShortDashDotDot: 16281 //' - - - -'
};
const cesiumDashNumberToDashArray = {
  0: [],
  255: [],
  3087: [6, 6],
  7: [1, 3],
  2017: [4, 3, 1, 3],
  16273: [8, 3, 1, 3, 1, 3],
  2047: [8, 3],
  4081: [8, 3, 1, 3],
  4095: [4, 1],
  13107: [1, 1],
  8179: [4, 1, 1, 1],
  16281: [4, 1, 1, 1, 1, 1]
};
export function convertCesiumDashNumberToDashArray(dashPattern) {
  if (cesiumDashNumberToDashArray[dashPattern]) {
    return cesiumDashNumberToDashArray[dashPattern];
  }
  return defaultDashArray;
}
export function convertEsriLineStyleToCesiumDashNumber(styleName) {
  if (styleName in esriLineStyleCesium) {
    return esriLineStyleCesium[styleName];
  }
  return undefined;
}
function convertEsriLineStyleToDashArray(styleName) {
  if (styleName) {
    const dashNumber = convertEsriLineStyleToCesiumDashNumber(styleName);
    if (dashNumber !== undefined) {
      return convertCesiumDashNumberToDashArray(dashNumber);
    }
  }
  return [];
}